import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDesignToolStamp = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "design-tool-stamp" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M21.68,21.75a1.5,1.5,0,0,1-1.492,1.5H3.78a1.5,1.5,0,0,1-1.492-1.5v-1.5H21.68Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M19.442,14.25H16.459c-1.946,0-2.529-1.272-2.529-2.739,0-2.446,2.432-3.928,2.432-6.359a4.378,4.378,0,1,0-8.756,0c0,2.431,2.432,3.913,2.432,6.359,0,1.467-.583,2.739-2.529,2.739H3.78c-3.6,0-3.607,6-2.011,6H22.2C23.752,20.25,24.132,14.25,19.442,14.25Z"
		})
	]
});
export default SvgDesignToolStamp;
